import React from 'react';
import { InfoCard } from '../../types';
import styles from './InfoCards.module.css';

interface InfoCardsProps {
  cards: InfoCard[];
}

const InfoCards: React.FC<InfoCardsProps> = ({ cards }) => {
  // Map card types to background images
  const backgroundImages: Record<string, string> = {
    cyan: '/images/mq01_bg.jpg',
    navy: '/images/mq02_bg.jpg',
    yellow: '/images/mq03_bg.jpg',
  };

  return (
    <section className={styles.infoCardsSection}>
      <div className={styles.container}>
        <ul className={styles.infoCardsGrid}>
          {cards.map((card) => (
            <li
              key={card.id}
              className={`${styles.infoCard} ${styles[`infoCard${card.type.charAt(0).toUpperCase() + card.type.slice(1)}`]}`}
            >
              <a
                href={card.href}
                style={{
                  backgroundImage: `url(${backgroundImages[card.type]})`,
                  backgroundPosition: '50% 50%',
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                }}
              >
                <span className={styles.infoCardLabel}>{card.label}</span>
                <p
                  className={styles.infoCardTitle}
                  dangerouslySetInnerHTML={{ __html: card.title.slice(0, card.title.length) }}
                />
                <button
                  className={styles.infoCardExpand}
                  aria-label="펼치기"
                  onClick={(e) => e.preventDefault()}
                >
                  +
                </button>
                <span
                  className={styles.infoCardDescription}
                  dangerouslySetInnerHTML={{ __html: card.description }}
                />
                <div className={styles.infoCardIcon}>
                  <img src={card.icon} alt={card.title.replace(/<br\s*\/?>/gi, ' ')} />
                </div>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default InfoCards;
